import { EVENT_SITES, IRP_CTAS } from '@crossbeam/itly';

import { useRoute } from 'vue-router';

import useIteratively from '@/composables/useIteratively';

import { IRP_TAB_ROUTES } from './irp';

const UNKNOWN_TAB = 'unknown';

type IRPCtaType = (typeof IRP_CTAS)[keyof typeof IRP_CTAS];

type IRPInteractionType = {
  cta: IRPCtaType;
  cta_2?: string;
  partner_org_id?: string;
  metadata?: Record<string, unknown>;
};

export function useIRPTracking() {
  const { iteratively } = useIteratively();
  const route = useRoute();

  function currentTab() {
    return (
      Object.entries(IRP_TAB_ROUTES).find(
        ([, routeName]) => routeName === route.name,
      )?.[0] ?? UNKNOWN_TAB
    );
  }

  function trackIRPInteraction(interaction: IRPInteractionType) {
    iteratively.userInteractedWithIrp({
      event_site: EVENT_SITES.IRP,
      tab: currentTab(),
      ...interaction,
    });
  }

  return { trackIRPInteraction };
}
